var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L14.2929 15.7071ZM9.90504 11.3193L14.2929 15.7071L15.7071 14.2929L11.3193 9.90504L9.90504 11.3193ZM7.535 13.07C10.5917 13.07 13.07 10.5915 13.07 7.53429H11.07C11.07 9.4871 9.4869 11.07 7.535 11.07V13.07ZM13.07 7.53429C13.07 4.47822 10.5914 2 7.53429 2V4C9.48721 4 11.07 5.5832 11.07 7.53429H13.07ZM7.53429 2C4.47843 2 2 4.47772 2 7.535H4C4 5.58228 5.583 4 7.53429 4V2ZM2 7.535C2 10.5915 4.47761 13.07 7.535 13.07V11.07C5.58239 11.07 4 9.4871 4 7.535H2Z",
    fill: "#004FEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.f3e4fd3e1f212ee5b84517fa0a7eeaa0.svg";
export { ForwardRef as ReactComponent };